import PropTypes from 'prop-types';
import { useUserDisplay, UserUtils } from '@cyberint/common-utils';

const formatters = {
  fullname: data => data?.fullname,
  username: data => data?.username,
  fullname_then_username: data => data?.fullname || data?.username,
  username_then_fullname: data => data?.username || data?.fullname
};

// Legacy ids carry an email-shaped portion after the slash so `getUserDisplayName`
// already produces a stable label. UUID ids return the raw UUID; render the
// `loadingFallback` (typically a skeleton) for that window instead of flashing
// the UUID and then jumping to the resolved name.
const isUnresolved = (data, userId) =>
  !data?.fullname && (!data?.username || data.username === userId) && userId && !userId.includes('/');

export const UserDisplay = ({ userId, format = 'fullname_then_username', fallback, loadingFallback }) => {
  const { data } = useUserDisplay(userId);
  if (!userId) return fallback || null;

  if (loadingFallback != null && isUnresolved(data, userId)) return loadingFallback;

  const formatter = typeof format === 'function' ? format : formatters[format] || formatters.fullname_then_username;
  return formatter(data) || UserUtils.getUserDisplayName(userId) || userId;
};

UserDisplay.propTypes = {
  userId: PropTypes.string,
  format: PropTypes.oneOfType([
    PropTypes.oneOf(['fullname', 'username', 'fullname_then_username', 'username_then_fullname']),
    PropTypes.func
  ]),
  fallback: PropTypes.node,
  loadingFallback: PropTypes.node
};
